// extracted by mini-css-extract-plugin
export default {"container":"trioOnMain-module__container--wO8MU","sliderWithOnlyTwoItems":"trioOnMain-module__sliderWithOnlyTwoItems--h5Z5r","root":"trioOnMain-module__root--ElkO4"};